import { defineNuxtPlugin } from '#imports';
import { getPersistedFbclid } from '~/helpers/metaTracking';

// Save fbclid as soon as the app loads, so it survives navigation through the
// booking journey and can be used to build meta_fbc when there is no _fbc cookie
export default defineNuxtPlugin(() => {
    getPersistedFbclid();
});
